import { capitalizeFirstLetter } from '@hb/shared'

export const getNestedName = (path: string) =>
  path.split('.').map(capitalizeFirstLetter).join(' → ')
